import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import "./carStyle.css";
export default class ProjectCarousel extends Component {
  render() {
    const { images } = this.props;
    if (images.length)
      return (
        <div>
          {/* <img src={images[0]} className="car-img" width="100%" /> */}
          <Carousel infiniteLoop={true} autoPlay={true} showThumbs={false}>
            {images.map((i,index) => 
            <div key={'image-'+index}>
              <img src={i} className="car-img" width="100%"  />
            </div>
                )}
          </Carousel>
        </div>
      );
    else return null;
  }
}
